import type { TLocalize } from '@hooks/use-localize';
import type { IDashboardModel } from '@/types/dashboard';

interface IProps {
    model: IDashboardModel;
    t: TLocalize;
}

const RuledOut = ({ model, t }: IProps) => (
    <div className='container'>
        {model.isAutoRuleOut ? (
            <div className="alert alert-danger">
                <div style={{ marginBottom: 5 }}>
                    <strong>
                        {t('DashLabel_BasedOnYourAnswers', 'Based on your answers to our screening survey, ')}{' '}
                        {model.centerName}{' '}
                        {t(
                            'DashLabel_ItWouldNotBeMedically',
                            'has determined it would not be medically safe for you to donate because of the following:',
                        )}
                    </strong>
                </div>
                <ul>
                    {model.ruleOutReasons.map((reason, index) => (
                        <li key={index}>{reason}</li>
                    ))}
                </ul>
            </div>
        ) : model.isManualRuleOut ? (
            <div className="alert alert-danger">
                <div style={{ marginBottom: 5 }}>
                    <strong>
                        {t(
                            'Alert_ItWasDeterminedByTheTransplantCenterNotAbleToDonate',
                            'It was determined by the transplant center that you would not be able to donate',
                        )}
                        .
                    </strong>
                </div>
                <div>
                    {t(
                        'DashLabel_TheTransplantCenterMarkedRegistrationRuledOut',
                        'The transplant center marked your registration as ruled out. This typically results when there is a medical issue that would make it unsafe for you to donate, but it can also happen if the transplant center was unable to contact you.To find out more, please contact the transplant center if the reason has not already been discussed with you',
                    )}
                    .
                </div>
            </div>
        ) : (
            <div className="alert alert-danger">
                <strong>{t('Alert_ThisLinkIsExpired', 'This link is expired or no longer valid')}</strong>
            </div>
        )}

        {model.offerRuleOutTransfer && (
            <div className="alert alert-success">
                <h3 style={{ color: 'black' }}>
                    {t('DashLabel_StillInterestedInDonating', 'Still interested in donating?')}
                </h3>
                <p>
                    {t(
                        'DashLabel_RuleOutTransferToNkrOffer',
                        "Through the National Kidney Registry's Referral Network, we did find at least one center, within 300 miles, that would be willing to evaluate you further. If you are interested in transferring your registration to the National Kidney Registry's Referral Network, you can click on the button below.",
                    )}
                    .
                </p>
                <br />
                <a href="/register/transfer-to-nkr" className="btn btn-primary">
                    {t(
                        'DashLabel_TransferRegistrationToNKR',
                        'Transfer Registration to National Kidney Registry',
                    )}
                </a>
            </div>
        )}
    </div>
);

export default RuledOut;
